<template>
  <div>
    <router-view name="header"></router-view>
    <router-view :key="key"></router-view>
  </div>
</template>
<script>
export default {
  name:'RouterEnterpriseGraph',
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
</style>
